import React from "react";
import { useNavigate } from "react-router-dom";


const DownloadLink = (props) => {
  let navigate = useNavigate();
  return (
    <div style={{ display: "inline-block", color: "primary", cursor:"pointer" }} onClick={() => { if (props?.to) navigate(props?.to); props?.onClick() }}>
      <i style={{ color: "primary" }} className="mdi mdi-download color-primary font-size-18" />
    </div>
  );
};
export default DownloadLink;